export default {
  "menu.welcome": "Chào mừng",
  "menu.more-blocks": "Thêm Khối",
  "menu.home": "Trang chủ",
  "menu.admin": "Quản trị",
  "menu.admin.sub-page": "Trang con",
  "menu.login": "Đăng nhập",
  "menu.register": "Đăng ký",
  "menu.register-result": "Kết quả đăng ký",

  "menu.users": "Quản lý người dùng",
  "menu.users.user-list": "Danh sách người dùng",
  "menu.users.user-detail": "Chi tiết người dùng",
  "menu.users.create-user": "Tạo người dùng mới",
  "menu.food-database": "Cơ sở dữ liệu thực phẩm",
  "menu.food-database.foods": "Thực phẩm",
  "menu.food-database.foods.food-list": "Danh sách thực phẩm",
  "menu.food-database.foods.create-food": "Tạo thực phẩm mới",
  "menu.food-database.foods.update-food": "Cập nhật thực phẩm",
  "menu.food-database.foods.food-detail": "Chi tiết thực phẩm",
  "menu.food-database.categories": "Danh mục",
  "menu.food-database.categories.category-list": "Danh sách danh mục",
  "menu.food-database.categories.create-category": "Tạo danh mục mới",
  "menu.food-database.categories.update-category": "Cập nhật danh mục",
  "menu.food-database.categories.category-detail": "Chi tiết danh mục",
  "menu.food-database.brands": "Thương hiệu",
  "menu.food-database.brands.brand-list": "Danh sách thương hiệu",
  "menu.food-database.brands.create-brand": "Tạo thương hiệu mới",
  "menu.food-database.brands.update-brand": "Cập nhật thương hiệu",
  "menu.food-database.brands.brand-detail": "Chi tiết thương hiệu",
  "menu.submissions": "Yêu cầu thực phẩm",
  "menu.submissions.pending-submissions": "Yêu cầu chờ duyệt",
  "menu.submissions.all-submissions": "Tất cả yêu cầu",
  "menu.submissions.submission-detail": "Chi tiết yêu cầu",
  "menu.submissions.review-submission": "Duyệt yêu cầu",
  "menu.submissions.submission-history": "Lịch sử yêu cầu",
  "menu.tools": "Công cụ",
  "menu.tools.check-barcode": "Kiểm tra Barcode",
  "menu.account.center": "Trung tâm tài khoản",
  "menu.account.settings": "Cài đặt",
  "menu.account.logout": "Đăng xuất",
};
